import { ISubscriptionListener, ISubscriptionUnsubscribe } from '@aytm/lib/common/subscription'
import { IModule } from '../types'

export type WidgetWidth = number | string
export const DEFAULT_WIDGET_WIDTH = {
  MOBILE: '100%',
  TABLET: 640,
  DESKTOP: 640
}

export const BANNER_WIDTH = 240

export enum ViewportScreenType {
  DESKTOP = 'pc',
  TABLET = 'tablet',
  MOBILE = 'mobile'
}
export enum ViewportDevice {
  DESKTOP = 'pc',
  MOBILE = 'mobile'
}
export enum ViewportOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape'
}

export interface IViewportPaddings {
  top: number
  right: number
  bottom: number
  left: number
}

export interface IViewportProps {
  width: number
  height: number
  autoHeight?: boolean
  maxAutoHeight?: number | string
  mobile: boolean
  tablet: boolean
  orientation: ViewportOrientation
  scale?: number
  touch?: boolean
  paddings?: IViewportPaddings
  emulationMobileFrame?: boolean
  emulationNoScrollBar?: boolean
  emulationMobileCursor?: boolean
  emulationScrollContainer?: boolean
}

export interface IViewport {
  onUpdate(listener: ISubscriptionListener<IViewport>): ISubscriptionUnsubscribe
  get width(): number
  get height(): number
  get autoHeight(): boolean
  get maxAutoHeight(): number | string
  updateAutoHeight(this: void, height: number): void
  get scale(): number
  get mobile(): boolean
  get tablet(): boolean
  get screenType(): ViewportScreenType
  get device(): ViewportDevice
  get widgetWidth(): WidgetWidth
  get orientation(): ViewportOrientation
  get touch(): boolean
  get paddings(): IViewportPaddings
  get emulated(): boolean
  get emulationMobileFrame(): boolean
  get emulationNoScrollBar(): boolean
  get emulationMobileCursor(): boolean
  get emulationScrollContainer(): boolean
}

export interface IViewportModuleProps {
  emulate?: IViewportProps
}

export interface IViewportModule extends IModule {
  config(props: IViewportModuleProps): IViewportModule
  set root(root: HTMLElement)
  get root(): HTMLElement
  get rootObserved(): boolean
  get viewport(): IViewport
  get realViewport(): IViewport
  applyPaddings(paddings: Partial<IViewportPaddings>): IViewportModule
  emulate(viewportProps?: IViewportProps): IViewportModule
  get emulated(): boolean
  update(): IViewportModule
  onUpdate(listener: ISubscriptionListener<IViewport>): ISubscriptionUnsubscribe
}

export enum UseViewportMode {
  CURRENT = 'current',
  REAL = 'real'
}

export interface IUseViewport {
  (mode?: UseViewportMode): IViewport
}
